import type { FeatureCollection, MultiPolygon } from 'geojson';
import { feature } from 'topojson-client';
import land110m from 'world-atlas/land-110m.json';

/**
 * 110m-resolution land polygons (~55 KB), shared by the 2D map and the 3D
 * globe's procedurally-rasterized texture — see the note on Earth imagery
 * in `docs/`: there is no satellite texture asset, so both views build
 * their land shapes from this single offline vector source.
 */
let cached: FeatureCollection<MultiPolygon> | null = null;

export function loadLand(): FeatureCollection<MultiPolygon> {
  if (cached) return cached;
  const topology = land110m as unknown as Parameters<typeof feature>[0];
  const land = (topology as unknown as { objects: { land: never } }).objects.land;
  cached = feature(topology, land) as unknown as FeatureCollection<MultiPolygon>;
  return cached;
}
